'use strict';

const helper = require('./helper');

const DATA_METHOD_ID_ATTRIBUTE = 'data-method-id';

function hideBillingAddressManipulationButtons() {
    document.querySelector('.address-selector-block .btn-show-details').style.display = 'none';
    document.querySelector('.address-selector-block .btn-add-new').style.display = 'none';
}

function showBillingAddressManipulationButtons() {
    document.querySelector('.address-selector-block .btn-show-details').style.display = '';
    document.querySelector('.address-selector-block .btn-add-new').style.display = '';
}

function disableBillingAddressList() {
    document.getElementById('billingAddressSelector').setAttribute('disabled', 'disabled');
}

function enableBillingAddressList() {
    document.getElementById('billingAddressSelector').removeAttribute('disabled');
}

function hideSubmitPaymentButton() {
    document.querySelector('.submit-payment').style.display = 'none';
}

function showSubmitPaymentButton() {
    document.querySelector('.submit-payment').style.display = '';
}

/**
 * Hides biiling address form on the Billing Page for appropriate tabs.
 * Case when customer clicked 'Updated address' or 'Add New' button and flipped through the payment method tabs
 */
function hideBillingAddressForm() {
    document.querySelector('.billing-address-block .billing-address').style.display = 'none';
}

/**
 * Shows biiling address form on the Billing Page for appropriate tabs.
 * Case when customer clicked 'Updated address' or 'Add New' button and flipped through the payment method tabs
 */
function showBillingAddressForm() {
    document.querySelector('.billing-address-block .billing-address').style.display = '';
}

/**
 * Hides phone field on the Billing Page for appropriate tabs
 */
function hidePhoneField() {
    document.querySelector('.dwfrm_billing_contactInfoFields_phone').style.display = 'none';
}

/**
 * Shows phone field on the Billing Page for appropriate tabs
 */
function showPhoneField() {
    // braintree customization
    // document.querySelector('.dwfrm_billing_contactInfoFields_phone').style.display = '';
}

/**
 * Disabled billing address functionality on the Billing Page
 */
function disableBillingAddressFunctionality() {
    disableBillingAddressList();
    hideBillingAddressManipulationButtons();
    hideBillingAddressForm();
    // hidePhoneField();
}

/**
 * Enabled billing address functionality on the Billing Page
 */
function enableBillingAddressFunctionality() {
    showBillingAddressManipulationButtons();
    enableBillingAddressList();
    showBillingAddressForm();
    // braintree customization
    // showPhoneField();
}

/**
 * Shows billing address block on the Billing Page
 */
function showBillingAddressBlock() {
    const billingAddressSelectorBlockEl = document.querySelector('.address-selector-block');

    if (billingAddressSelectorBlockEl?.classList.contains('d-none')) {
        billingAddressSelectorBlockEl.classList.remove('d-none');
    }
}

/**
 * Hides billing address block on the Billing Page
 */
function hideBillingAddressBlock() {
    const billingAddressSelectorBlockEl = document.querySelector('.address-selector-block');

    if (!billingAddressSelectorBlockEl?.classList.contains('d-none')) {
        billingAddressSelectorBlockEl.classList.add('d-none');
    }
}

/**
 * Returns a billing address represented as a string
 * @param {Object} billingAddress A billing address object
 * @returns {string} A string represented a billing address
 */
function formatBaAsString(billingAddress) {
    const firstName = billingAddress.firstName || '';
    const lastname = billingAddress.lastName || '';
    const address1 = billingAddress.line1 || billingAddress.address1 || billingAddress.streetAddress || '';
    const city = billingAddress.city || billingAddress.locality || '';
    const state = billingAddress.state || billingAddress.stateCode || billingAddress.region || '';
    const postalCode = decodeURIComponent(billingAddress.postalCode) || '';

    return `${firstName} ${lastname} ${address1} ${city}, ${state} ${postalCode}`;
}

/**
 * Extract billing address of corresponding payment account from account option
 * @param {Object} $selectedPayment PayPal payment option
 * @returns {string} return string representation of extracted address
 */
function getBillingAddressAsString($selectedPayment) {
    const selectedBillingAddressStr = $selectedPayment.getAttribute('data-billing-address');

    let billingAddressRepresentationString = '';

    if (selectedBillingAddressStr) {
        const selectedBillingAddressObj = helper.tryParseJSON(selectedBillingAddressStr);

        helper.updateStorefrontBillingData(selectedBillingAddressObj);

        if (selectedBillingAddressObj && selectedBillingAddressStr !== '{}') {
            billingAddressRepresentationString = formatBaAsString(selectedBillingAddressObj);
        }
    }

    return billingAddressRepresentationString;
}

/**
 * It gets the ID of the last billing address used for the selected payment method
 * @param {Element} paymentOption - The payment option that was selected.
 * @returns {string} - The billing address ID that was stored in session storage.
 */
function getStoredBillingAddressId(paymentOption) {
    const billingAddressSelect = document.getElementById('billingAddressSelector');
    const availableBillingAddressIds = Array.from(billingAddressSelect.options)
        .filter((option) => !(option.disabled || option.value === 'new'))
        .map((option) => option.value);

    const selectedPaymentMethod = paymentOption.getAttribute(DATA_METHOD_ID_ATTRIBUTE);
    const isLPM = selectedPaymentMethod !== 'CREDIT_CARD';
    const selectedPMStoredBillingAddressId = sessionStorage.getItem(`${selectedPaymentMethod}-last-billing-id`);

    if (selectedPMStoredBillingAddressId && !availableBillingAddressIds.includes(selectedPMStoredBillingAddressId)) {
        return availableBillingAddressIds[0];
    }

    if (isLPM && !selectedPMStoredBillingAddressId) {
        return sessionStorage.getItem('CREDIT_CARD-last-billing-id');
    }

    return selectedPMStoredBillingAddressId;
}

/**
 * It sets the billing address ID in session storage for the selected payment method
 * @param {Element} paymentOption - The payment method that was selected.
 * @param {Element} billingOption - The billing address option that was selected.
 */
function setStoredBillingAddressId(paymentOption, billingOption) {
    const selectedPaymentMethodName = paymentOption.getAttribute(DATA_METHOD_ID_ATTRIBUTE);

    if (billingOption.getAttribute('value') !== null) {
        sessionStorage.setItem(`${selectedPaymentMethodName}-last-billing-id`, billingOption.getAttribute('value'));
    }
}

/**
 * Removes payment method selected billing address id from the session storage
 */
function removeStoredBillingAddressIds() {
    const storedKeys = Object.keys(sessionStorage).filter((key) => key.match(/-last-billing-id/));

    storedKeys.forEach((key) => sessionStorage.removeItem(key));
}

/**
 * It creates an option element, sets its text, class, and selected property, and then appends it to
 * the billingAddressSelector element
 * @param {string} className - Class name of the option element.
 * @param {string} innerText - Text that will be displayed in the dropdown menu.
 */
function createBillingAddressOption(className, innerText) {
    const billingAddressSelector = document.getElementById('billingAddressSelector');
    const option = document.createElement('option');

    option.innerText = innerText;
    option.className = className;
    option.selected = true;

    billingAddressSelector.append(option);
}

/**
 * It prefills NLPM form fields
 * @param {Element} paymentOption payment option
 */
function prefillNLPMFields(paymentOption) {
    const nlpmId = paymentOption.getAttribute(DATA_METHOD_ID_ATTRIBUTE);

    const billingEl = document.querySelector('.summary-details.billing');
    const pmContentEl = document.querySelector(`.js_braintree_${nlpmId}Content`);

    const nlpmFieldEls = pmContentEl.querySelectorAll('.js-nlpm-field');

    nlpmFieldEls.forEach((fieldEl) => {
        if (fieldEl.value !== '') {
            return;
        }

        const getTrimmedBillingField = selector => billingEl.querySelector(selector).textContent.trim();

        switch (fieldEl.id.split('-').pop()) {
            case 'phone':
                fieldEl.value = getTrimmedBillingField('.order-summary-phone');

                break;
            case 'fullName':
                fieldEl.value = `${getTrimmedBillingField('.firstName')} ${getTrimmedBillingField('.lastName')}`;

                break;
        }
    });
}

/**
 * Updates the billing address form values within saved billing
 * @param {Object} billingAddress billing address
 */
function updateBillingAddressFormValues(billingAddress) {
    const form = document.querySelector('form[name=dwfrm_billing]');
    var inputNames = ['firstName', 'lastName', 'address1', 'address2', 'city', 'postalCode'];

    // Braintree customization because, in case of Poland we are not showing address2 field on UI but it is mandatory field in address form, so we need to remove address2 field from inputNames array to avoid issue with filling address form values
    if (billingAddress.countryCode === 'PL') {
        inputNames = inputNames.filter(function(name) {
            return name !== 'address2';
        });
    }

    if (!form) {
        return;
    }

    inputNames.forEach((value) => {
        form.querySelector(`input[name$=_${value}]`).value = decodeURIComponent(billingAddress[value]);
    });

    // Process the billing address select elements (Country, State)
    ['select[name$=_stateCode]', 'input[name$=_stateCode]', 'select[name$=_country]', 'input[name$=_country]']
        .forEach((elemSelector) => {
            const $elem = form.querySelector(elemSelector);

            if ($elem) {
                $elem.value = elemSelector.includes('stateCode') ? billingAddress.stateCode : (billingAddress.country || billingAddress.countryCode);
            }
        });
}

/**
 * Sets billing address selector value to a session stored billing address id and updates billing form with that address
 * @param {string} paymentOption Payment option
 */
function setBillingAddressSelectValue(paymentOption) {
    const billingAddressSelector = document.getElementById('billingAddressSelector');
    const billingAddressId = getStoredBillingAddressId(paymentOption);

    if (billingAddressId) {
        const billingAddressToSelect = Array.from(billingAddressSelector.children).find((option) => {
            const stroredBillingAddress = option.value;

            return stroredBillingAddress === billingAddressId
                || stroredBillingAddress === `ab_${billingAddressId}`
                || `ab_${stroredBillingAddress}` === billingAddressId;
        });

        if (billingAddressToSelect) {
            billingAddressToSelect.selected = true;

            updateBillingAddressFormValues(billingAddressToSelect.dataset);
        }
    }
}

module.exports = {
    disableBillingAddressFunctionality,
    enableBillingAddressFunctionality,
    hideBillingAddressManipulationButtons,
    showBillingAddressManipulationButtons,
    disableBillingAddressList,
    enableBillingAddressList,
    hideBillingAddressForm,
    showBillingAddressForm,
    hideSubmitPaymentButton,
    showSubmitPaymentButton,
    hidePhoneField,
    showPhoneField,
    setStoredBillingAddressId,
    removeStoredBillingAddressIds,
    createBillingAddressOption,
    getBillingAddressAsString,
    prefillNLPMFields,
    updateBillingAddressFormValues,
    setBillingAddressSelectValue,
    formatBaAsString,
    showBillingAddressBlock,
    hideBillingAddressBlock
};
